/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";
import FormNewConsultation from "../../components/FormNewConsultation";
import Modal from "../../components/Modal";
import toast, { Toaster } from "react-hot-toast";
import { useSystemConfig } from "../../context/systemConfigContext";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import ConsultationPageHeader from "../../components/patients/consultation/ConsultationPageHeader";
import ConsultationActionBar from "../../components/patients/consultation/ConsultationActionBar";
import ConsultationTabsNav from "../../components/patients/consultation/ConsultationTabsNav";
import ConsultationTypeSelector from "../../components/patients/consultation/ConsultationTypeSelector";
import PatientRecordsModalContent from "../../components/patients/consultation/PatientRecordsModalContent";
import ConsultationDocumentsModalContent from "../../components/patients/consultation/ConsultationDocumentsModalContent";
import LastEyeglassPrescriptionModalContent from "../../components/patients/consultation/LastEyeglassPrescriptionModalContent";
import PatientModuleLayout from "../../components/patients/layout/PatientModuleLayout";

const getAvailableTabs = (ophthalmologyEnabled = true) => {
    const baseTabs = [
        { name: "General", current: true },
    ];
    
    const ophthalmologyTabs = ophthalmologyEnabled ? [
        { name: "Visión y Tensión", current: false },
        { name: "Refracción", current: false },
        { name: "Dibujo ocular", current: false },
    ] : [];
    
    const medicationTab = [
        { name: "Medicación", current: false },
    ];
    
    const ophthalmologicalStudiesTab = ophthalmologyEnabled ? [
        { name: "Estudios oftalmológicos", current: false },
    ] : [];
    
    const clinicalStudiesTab = [
        { name: "Estudios clínicos", current: false },
    ];
    
    const surgeryTab = [
        { name: 'Cirugía', current: false },
    ];
    
    return [
        ...baseTabs,
        ...ophthalmologyTabs,
        ...medicationTab,
        ...ophthalmologicalStudiesTab,
        ...clinicalStudiesTab,
        ...surgeryTab,
    ];
};

const TAB_DOCUMENT_TYPES = {
    Refracción: "refraction",
    Medicación: "medication",
    "Estudios oftalmológicos": "ophthalmological_study",
    "Estudios clínicos": "clinical_study",
    Cirugía: "surgery_order",
};

const consultationTypes = [
    { name: "General", value: 1 },
    { name: "De especialidad", value: 2 },
];

const consultationASubtypes = [
    { name: "Control de rutina", value: 4 },
    { name: "Control por tratamiento", value: 1 },
    { name: "Control post quirúrgico", value: 2 },
    { name: "Estudios", value: 3 },
];

const consultationBSubtypes = [
    { name: "Control por tratamiento", value: 1 },
    { name: "Control post quirúrgico", value: 2 },
    { name: "Estudios", value: 3 },
];

const getAge = (dateString) => {
    if (!dateString) return null;
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};

export default function ConsultationNewPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarOpenDesktop, setSidebarOpenDesktop] = useState(true);
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [loadingSubmitRecords, setLoadingSubmitRecords] = useState(false);
    const [openRecords, setOpenRecords] = useState(false);
    const [openLastsPrescription, setOpenLastsPrescription] = useState(false);
    const [openDocuments, setOpenDocuments] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [submitError, setSubmitError] = useState("");
    const [hasSelectedType, setHasSelectedType] = useState(true);
    const [hasSelectedSubtype, setHasSelectedSubtype] = useState(true);
    const [patientDocument, setPatientDocument] = useState({ documents: [] });
    const { idPatient } = useParams();
    const { idConsultation: urlIdConsultation } = useParams();
    const [idConsultation, setIdConsultation] = useState(urlIdConsultation);
    const [tab, setTab] = useState("General");
    const [printWithInsurance, setPrintWithInsurance] = useState(true);
    // eslint-disable-next-line no-unused-vars
    const [userId, setUserId] = useState(
        JSON.parse(localStorage.getItem("BDOuserData"))?.id
    );
    const [patient, setPatient] = useState([]);
    const [medicines, setMedicines] = useState([]);
    const [surgeries, setSurgeries] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const navigate = useNavigate();
    const { config } = useSystemConfig();
    const [tabs, setTabs] = useState(getAvailableTabs(true));

    useEffect(() => {
        const documentType = TAB_DOCUMENT_TYPES[tab];
        if (!documentType) return;
        api.printTemplates
            .resolve(documentType, userId)
            .then((r) => setPrintWithInsurance(r.showInsuranceDefault))
            .catch(() => setPrintWithInsurance(true));
    }, [tab, userId]);

    useEffect(() => {
        if (isDesktop) {
            setSidebarOpen(false);
        }
    }, [isDesktop]);

    const handleSidebarToggle = () => {
        if (isDesktop) {
            setSidebarOpenDesktop(!sidebarOpenDesktop);
            return;
        }
        setSidebarOpen(!sidebarOpen);
    };

    const [consultation, setConsultation] = useState({
        patient: parseInt(idPatient),
        doctor: userId,
        consultationDate: new Date().toISOString().split("T")[0],
        consultationCategory: 2,
        consultationType: 1,
    });
    const initialConsultationRef = useRef(consultation);
    const [errors, setErrors] = useState({});
    const handleChange = (field, value) =>
        setConsultation((prev) => ({ ...prev, [field]: value }));
    const handlePatient = (field, value) =>
        setPatient((prev) => ({ ...prev, [field]: value }));
    const handleError = (field, value) =>
        setErrors((prev) => ({ ...prev, [field]: value }));

    const notify = (message, type = "success") => {
        toast(message, {
            style: {
                background: type === "success" ? "#4caf50" : "#f44336",
                color: "#fff",
                padding: "16px",
                borderRadius: "8px",
            },
            duration: 4000,
        });
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const formHasChanges =
                JSON.stringify(consultation) !==
                JSON.stringify(initialConsultationRef.current);
            if (formHasChanges) {
                event.preventDefault();
                event.returnValue = "";
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [consultation]);

    useEffect(() => {
        api.patients.getHistory(idPatient, "date").then(
            (response) => (
                setHistory({
                    ...response,
                    consultationList: response.consultationList
                        ? response.consultationList.map((element, idx) => ({
                              ...element,
                              index: idx + 1,
                              prescription: element.prescription ? "Si" : "No",
                          }))
                        : undefined,
                })
            )
        );
        api.patients
            .getOne(idPatient)
            .then((response) => {
                setPatient({
                    ...response,
                    name: response.firstName + " " + response.lastName,
                });
            })
            .catch((error) => console.log(error));
        api.medicines.getMulti().then((response) => {
            setMedicines(response);
        });
        api.surgeries.getMulti().then((response) => {
            setSurgeries(response);
        });
        api.users.getDoctors().then((response) => {
            setDoctors(
                response.map((element) => ({
                    name: `${element.sex === "Masculino" ? "Dr." : "Dra."} ${
                        element.firstName
                    } ${element.lastName}`,
                    ...element,
                }))
            );
        });
    }, []);

    useEffect(() => {
        if (urlIdConsultation) {
            setIdConsultation(urlIdConsultation);
            api.consultations.getOne(urlIdConsultation).then((response) => {
                setConsultation(response);
                setDocuments(response.documents);
            });
        }
    }, [urlIdConsultation]);

    useEffect(() => {
        if (config) {
            const availableTabs = getAvailableTabs(config.ophthalmologyModuleEnabled);
            // Asegurar que General esté activa
            const generalIdx = availableTabs.findIndex((tab) => tab.name === "General");
            if (generalIdx >= 0) {
                availableTabs.forEach((tab, idx) => {
                    tab.current = idx === generalIdx;
                });
            }
            setTabs(availableTabs);
        }
    }, [config]);

    const pages = [
        { name: "Pacientes", href: "/patients", current: false },
        {
            name: `${patient.name}`,
            href: `/patients/${idPatient}`,
            current: false,
        },
        {
            name: idConsultation ? "Ver consulta" : "Nueva consulta",
            href: "#",
            current: true,
        },
    ];
    const shouldShowConsultationForm = hasSelectedSubtype || idConsultation;
    const currentSubtypeOptions =
        consultation.consultationCategory === 1
            ? consultationASubtypes
            : consultationBSubtypes;

    const changeTab = (value) => {
        if (!tabs || tabs.length === 0) return;
        const fullOrder = getAvailableTabs(true).map((t) => t.name);
        const currentTabIndex = tabs.findIndex((t) => t.current);
        const direction =
            fullOrder.indexOf(value) >=
            fullOrder.indexOf(tabs[currentTabIndex]?.name)
                ? 1
                : -1;
        let target = tabs.some((t) => t.name === value) ? value : null;
        for (
            let i = fullOrder.indexOf(value);
            !target && i >= 0 && i < fullOrder.length;
            i += direction
        ) {
            if (tabs.some((t) => t.name === fullOrder[i])) target = fullOrder[i];
        }
        if (!target) return;

        setTabs(tabs.map((t) => ({ ...t, current: t.name === target })));
        setTab(target);
    };

    const checkIfEmpty = (medication) => {
        if (
            medication.medicine ||
            medication.medicineQuery?.trim() ||
            medication.periodNumber !== "" ||
            medication.quantity !== "" ||
            medication.frequencyNumber !== "" ||
            medication.observations !== ""
        )
            return false;
        else return true;
    };

    const validateConsultation = (consultation) => {
        let validationErrors = {};
        let hasError = false;
        let errorTab = "General";
        const meds = consultation.medications || [];
        const ophthalmologyModuleEnabled =
            config?.ophthalmologyModuleEnabled !== false;

        const isEmptyHtml = (value) => {
            if (!value) return true;
            const noTags = value
                .replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/g, " ")
                .trim();
            return noTags === "";
        };

        const isMedicationRowEmpty = (m) => {
            if (!m) return true;
            return !(
                m.medicine ||
                m.medicineQuery?.trim() ||
                (m.quantity !== undefined &&
                    m.quantity !== null &&
                    String(m.quantity).trim() !== "") ||
                (m.frequencyNumber !== undefined &&
                    m.frequencyNumber !== null &&
                    String(m.frequencyNumber).trim() !== "") ||
                (m.periodNumber !== undefined &&
                    m.periodNumber !== null &&
                    String(m.periodNumber).trim() !== "") ||
                (m.observations !== undefined &&
                    m.observations !== null &&
                    String(m.observations).trim() !== "")
            );
        };

        const isPositiveInt = (v) =>
            /^\d+$/.test(String(v).trim()) && parseInt(v, 10) > 0;

        // Validaciones de Medicación
        if (meds.length > 0) {
            const medsErrors = [];
            meds.forEach((m, idx) => {
                if (isMedicationRowEmpty(m)) return;
                const rowErrors = {};
                if (!m?.medicine)
                    rowErrors.medicine = m?.medicineQuery?.trim()
                        ? "Selecciona un medicamento de la lista o créalo con el botón +"
                        : "Este campo es obligatorio";
                if (
                    m?.quantity === undefined ||
                    m?.quantity === null ||
                    String(m.quantity).trim() === ""
                ) {
                    rowErrors.quantity = "Este campo es obligatorio";
                } else if (!isPositiveInt(m.quantity)) {
                    rowErrors.quantity = "Debe ser un número entero mayor a 0";
                }
                if (!m?.presentation)
                    rowErrors.presentation = "Este campo es obligatorio";
                if (
                    m?.frequencyNumber === undefined ||
                    m?.frequencyNumber === null ||
                    String(m.frequencyNumber).trim() === ""
                ) {
                    rowErrors.frequencyNumber = "Este campo es obligatorio";
                } else if (!isPositiveInt(m.frequencyNumber)) {
                    rowErrors.frequencyNumber =
                        "Debe ser un número entero mayor a 0";
                }
                if (!m?.frequency)
                    rowErrors.frequency = "Este campo es obligatorio";
                // if (!m?.period) rowErrors.period = "Este campo es obligatorio";
                // periodNumber obligatorio SIEMPRE que exista medicación, excepto "De por vida" (period === 5)
                // if (m?.period !== 5) {
                //     if (
                //         m?.periodNumber === undefined ||
                //         m?.periodNumber === null ||
                //         String(m.periodNumber).trim() === ""
                //     ) {
                //         rowErrors.periodNumber = "Este campo es obligatorio";
                //     } else if (!isPositiveInt(m.periodNumber)) {
                //         rowErrors.periodNumber =
                //             "Debe ser un número entero mayor a 0";
                //     }
                // }
                // Validar que eye sea obligatorio cuando presentation es Colirio (id: 1)
                if (m?.presentation === 1) {
                    if (!m?.eye) {
                        rowErrors.eye =
                            "El campo ojo es obligatorio cuando la presentación es colirio";
                    }
                }
                if (Object.keys(rowErrors).length > 0) {
                    medsErrors[idx] = rowErrors;
                }
            });
            if (medsErrors.some(Boolean)) {
                validationErrors.medications = medsErrors;
                if (!hasError) {
                    hasError = true;
                    errorTab = "Medicación";
                } else {
                    hasError = true;
                }
            }
        }

        // Validaciones de Refracción
        if (ophthalmologyModuleEnabled && consultation.refraction) {
            const refr = consultation.refraction;

            const decimalFields = [
                "farVisionSphericalRight",
                "farVisionSphericalLeft",
                "farVisionCylindricalRight",
                "farVisionCylindricalLeft",
                "nearVisionSphericalRight",
                "nearVisionSphericalLeft",
                "nearVisionCylindricalRight",
                "nearVisionCylindricalLeft",
            ];

            const isDecimalWithSign = (value) =>
                /^[-+]?\d+(\.\d+)?$/.test(value);

            decimalFields.forEach((field) => {
                const value = refr[field];
                if (value !== undefined && value !== null && value !== "") {
                    const str = String(value).trim();
                    if (!isDecimalWithSign(str)) {
                        validationErrors[field] =
                            "Debe ser un número decimal con o sin signo";
                        hasError = true;
                        errorTab = "Refracción";
                    }
                }
            });

            if (
                refr.intrapupillaryDistance !== undefined &&
                refr.intrapupillaryDistance !== null &&
                refr.intrapupillaryDistance !== ""
            ) {
                const intValue = String(refr.intrapupillaryDistance).trim();
                if (!/^\d+$/.test(intValue)) {
                    validationErrors.intrapupillaryDistance =
                        "Debe ser un número entero";
                    hasError = true;
                    errorTab = "Refracción";
                }
            }
        }

        // Validar campos de General
        if (isEmptyHtml(consultation.general?.motiveOfConsultation)) {
            validationErrors.motiveOfConsultation = "Este campo es obligatorio";
            hasError = true;
            errorTab = "General";
        }

        if (
            !consultation.general?.diagnoses ||
            consultation.general?.diagnoses.length === 0
        ) {
            validationErrors.diagnoses = "Este campo es obligatorio";
            hasError = true;
            errorTab = "General";
        }

        return { hasError, errorTab, validationErrors };
    };

    const handleSubmit = async (event, finish) => {
        event?.preventDefault?.();

        setErrors({});
        const { hasError, errorTab, validationErrors} =
            validateConsultation(consultation);

        if (hasError) {
            Object.keys(validationErrors).forEach((field) => {
                handleError(field, validationErrors[field]);
            });
            
            // Verificar que la pestaña de error existe en las pestañas disponibles
            const errorTabExists = tabs.some((tab) => tab.name === errorTab);
            const targetTab = errorTabExists ? errorTab : "General";
            
            const newTabs = [...tabs];
            const currentIdx = newTabs.findIndex((tab) => tab.current);
            if (currentIdx >= 0) newTabs[currentIdx].current = false;
            const errorIdx = newTabs.findIndex((tab) => tab.name === targetTab);
            if (errorIdx >= 0) {
                newTabs[errorIdx].current = true;
                setTabs(newTabs);
                setTab(targetTab);
            }
            return;
        }

        let request = { ...consultation };
        setLoadingSubmit(true);
        setSubmitError("");

        if (request.medications) {
            const nonEmptyMedications = request.medications.filter(
                (element) => !checkIfEmpty(element)
            );

            if (nonEmptyMedications.length === 0) {
                request = { ...request, medications: [] };
            } else {
                request = {
                    ...request,
                    medications: nonEmptyMedications.map(
                        ({ medicineQuery, ...element }) =>
                            element.period === 5
                                ? { ...element, periodNumber: 0 }
                                : element
                    ),
                };
            }
        }

        let diagnosesIds = [];
        if (request.general?.diagnoses) {
            diagnosesIds = request.general.diagnoses
                .map((d) => {
                    if (typeof d === "number") return d;
                    if (typeof d === "object" && d !== null && d.id)
                        return d.id;
                    if (typeof d === "string" && !isNaN(d))
                        return parseInt(d, 10);
                    return null;
                })
                .filter((id) => id !== null);
        }

        let surgeryIds = [];
        if (request.surgeryOrder?.surgeries) {
            surgeryIds = request.surgeryOrder.surgeries
                .map((s) => {
                    if (typeof s === "number") return s;
                    if (typeof s === "object" && s !== null && s.id)
                        return s.id;
                    return null;
                })
                .filter((id) => id !== null);
        }

        const payload = {
            ...request,
            general: {
                ...request.general,
                diagnoses: diagnosesIds,
            },
            surgeryOrder: request.surgeryOrder
                ? {
                      surgeryIds: surgeryIds,
                      generalObservations:
                          request.surgeryOrder.generalObservations || "",
                  }
                : undefined,
        };

        try {
            const response = idConsultation
                ? await api.consultations.update(idConsultation, payload)
                : await api.consultations.create(payload);

            const consultationId = idConsultation || response.id;

            if (!idConsultation && response.id) {
                setIdConsultation(response.id);
            }
            await uploadDocumentsForConsultation(consultationId);
            
            if (finish) {
                try {
                    const today = new Date();
                    const todayStr = today.toISOString().split('T')[0];
                    
                    const filterParams = {
                        patient: parseInt(idPatient),
                        doctor: userId,
                        attended: false,
                        missed_appointment: false,
                        date: todayStr,
                    };
                    
                    const turnsResponse = await api.turns.getMulti(
                        null,
                        null,
                        null,
                        null,
                        filterParams
                    );
                    
                    if (turnsResponse && turnsResponse.length > 0) {
                        const activeTurn = turnsResponse[0];
                        await api.turns.update(activeTurn.id, { attended: true });
                    }
                } catch (turnError) {
                    console.error("Error al marcar turno como atendido:", turnError);
                }
                
                navigate(`/patients/${idPatient}`);
            }
            notify("Datos guardados exitosamente", "success");
            setLoadingSubmit(false);
        } catch (error) {
            console.error("Error al guardar consulta:", error);

            if (error.message) {
                if (typeof error.message === "object") {
                    setSubmitError(error.message);

                    if (error.message.medications) {
                        const medicationTabExists = tabs.some((tab) => tab.name === "Medicación");
                        if (medicationTabExists) {
                            const newTabs = [...tabs];
                            const currentIdx = newTabs.findIndex((tab) => tab.current);
                            if (currentIdx >= 0) newTabs[currentIdx].current = false;
                            const medIdx = newTabs.findIndex((tab) => tab.name === "Medicación");
                            if (medIdx >= 0) {
                                newTabs[medIdx].current = true;
                                setTabs(newTabs);
                                setTab("Medicación");
                            }
                        }
                    }
                } else {
                    setSubmitError({ detail: error.message });
                }
            } else if (error.code === "serverError") {
                setSubmitError({
                    detail: "Error del servidor. Por favor, intente nuevamente.",
                });
            } else {
                setSubmitError({
                    detail: "Error inesperado. Por favor, intente nuevamente.",
                });
            }

            setLoadingSubmit(false);
        }
    };

    const handleSubmitPatient = () => {
        setLoadingSubmitRecords(true);
        api.patients
            .update(idPatient, patient)
            .then((response) => {
                console.log(response);
                setLoadingSubmitRecords(false);
                setOpenRecords(false);
            })
            .catch((error) => {
                setLoadingSubmitRecords(false);
            });
    };

    const handleFileSelect = (files) => {
        const mapped = files.map((file) => ({
            file,
            name: file.name.split(".")[0],
            extension: file.name.split(".").pop(),
        }));

        setPatientDocument((prev) => ({
            ...prev,
            documents: [...prev.documents, ...mapped],
        }));
    };

    const uploadDocumentsForConsultation = async (consultationId) => {
        if (!patientDocument.documents.length) return;

        const uploadDate = new Date().toISOString().split("T")[0];

        const uploadPromises = patientDocument.documents.map((doc) => {
            const finalName = `${doc.name}.${doc.extension}`;

            const formData = new FormData();
            formData.append("patient", idPatient.toString());
            formData.append("consultation", consultationId);
            formData.append("document", doc.file);
            formData.append("name", finalName);
            formData.append("uploadedBy", userId);
            formData.append("uploadDate", uploadDate);

            return api.documents.create(formData);
        });

        const createdDocuments = await Promise.all(uploadPromises);

        setDocuments((prev) => [...prev, ...createdDocuments]);
        setConsultation((prev) => ({
            ...prev,
            documents: [...(prev.documents || []), ...createdDocuments],
        }));

        setPatientDocument({ documents: [] });
    };

    return (
        <PatientModuleLayout
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarOpenDesktop={sidebarOpenDesktop}
            header={
                <ConsultationPageHeader
                    idPatient={idPatient}
                    patientName={patient?.name}
                    pages={pages}
                    handleSidebarToggle={handleSidebarToggle}
                />
            }
        >
            <Modal
                content={
                    <PatientRecordsModalContent
                        patient={patient}
                        handlePatient={handlePatient}
                        handleSubmitPatient={handleSubmitPatient}
                        loadingSubmitRecords={loadingSubmitRecords}
                        onClose={() => setOpenRecords(false)}
                    />
                }
                open={openRecords}
                setOpen={setOpenRecords}
                size="sm:max-w-4xl w-full"
            />
            <Modal
                content={
                    <LastEyeglassPrescriptionModalContent
                        patient={patient}
                        onClose={() => setOpenLastsPrescription(false)}
                    />
                }
                open={openLastsPrescription}
                setOpen={setOpenLastsPrescription}
                size="sm:max-w-4xl w-full"
            />
            <Modal
                content={
                    <ConsultationDocumentsModalContent
                        documents={documents}
                        patientDocument={patientDocument}
                        setPatientDocument={setPatientDocument}
                        handleFileSelect={handleFileSelect}
                        onClose={() => setOpenDocuments(false)}
                    />
                }
                open={openDocuments}
                setOpen={setOpenDocuments}
                size="sm:max-w-2xl w-full"
            />
            {shouldShowConsultationForm ? (
                <div className="mx-auto flex w-full max-w-[1600px] flex-1 flex-col gap-5 px-4 py-4 lg:px-6 lg:py-6">
                    <ConsultationActionBar
                        patientName={patient?.name}
                        patientGovId={patient?.govId}
                        patientAge={getAge(patient?.birthdate)}
                        consultationDateLabel={
                            consultation.consultationDate
                                ? consultation.consultationDate
                                      .split("-")
                                      .reverse()
                                      .join("/")
                                : ""
                        }
                        onOpenRecords={() => setOpenRecords(true)}
                        onOpenLastPrescription={() =>
                            setOpenLastsPrescription(true)
                        }
                        onOpenDocuments={() => setOpenDocuments(true)}
                        onSave={(event) => handleSubmit(event, false)}
                        onFinish={(event) => handleSubmit(event, true)}
                        loadingSubmit={loadingSubmit}
                        showLastPrescription={
                            config?.ophthalmologyModuleEnabled !== false
                        }
                    />

                    {(submitError.nonFieldErrors ||
                        submitError.detail ||
                        submitError.medications) && (
                        <section className="rounded-3xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
                            {submitError.nonFieldErrors && (
                                <div>{submitError.nonFieldErrors}</div>
                            )}
                            {submitError.detail && (
                                <div>{submitError.detail}</div>
                            )}
                            {submitError.medications &&
                                typeof submitError.medications === "string" && (
                                    <div>{submitError.medications}</div>
                                )}
                        </section>
                    )}

                    <ConsultationTabsNav tabs={tabs} onChange={changeTab} />

                    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
                        <form>
                            <FormNewConsultation
                                idConsultation={idConsultation}
                                medicines={medicines}
                                surgeries={surgeries}
                                doctors={doctors}
                                userId={userId}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                history={history}
                                refractionRecords={
                                    history.consultationList
                                        ? history?.consultationList.filter(
                                              (element) =>
                                                  element.refraction
                                          )
                                        : undefined
                                }
                                medicationsRecords={
                                    history.consultationList
                                        ? history?.consultationList.filter(
                                              (element) =>
                                                  element.medications
                                          )
                                        : undefined
                                }
                                loadingSubmit={loadingSubmit}
                                consultation={consultation}
                                changeTab={changeTab}
                                tab={tab}
                                age={getAge(patient?.birthdate)}
                                handleError={handleError}
                                errors={errors}
                                printWithInsurance={printWithInsurance}
                                setPrintWithInsurance={setPrintWithInsurance}
                            />
                        </form>
                    </div>
                    <Toaster />
                </div>
            ) : (
                <ConsultationTypeSelector
                    showingSubtypes={hasSelectedType}
                    typeOptions={consultationTypes}
                    subtypeOptions={currentSubtypeOptions}
                    onSelectType={(value) => {
                        handleChange("consultationCategory", value);
                        setHasSelectedType(true);
                    }}
                    onSelectSubtype={(value) => {
                        handleChange("consultationType", value);
                        setHasSelectedSubtype(true);
                    }}
                    onBack={() => setHasSelectedType(false)}
                />
            )}
        </PatientModuleLayout>
    );
}
